import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';

import t from './common/localization';
import EditItemView from './EditItemView';
import deviceModelsAttributes from './attributes/deviceModelsAttributes';
import { Accordion, AccordionSummary, AccordionDetails, makeStyles, Typography, FormControlLabel, Checkbox,
  Paper } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import EditAttributesView from './attributes/EditAttributesView';
import deviceAttributes from './attributes/deviceAttributes';
import { deviceCategories } from './common/deviceCategories';
import LinkField from './form/LinkField';
import { prefixString } from './common/stringUtils';
import Grid from '@material-ui/core/Grid';
import Styles from '@material-ui/core/styles';
import FormControl from "@material-ui/core/FormControl";

const useStyles = makeStyles(() => ({
  details: {
    flexDirection: 'flex',
  },
  textField: {
               margin: '4px',
               width: '85%',
    },
  root: {
              padding: '10px',
              margin: '10px',
              marginLeft: '60px',
              },
}));

const DeviceModelPage = () => {
  const classes = useStyles();

  const [item, setItem] = useState();

  return (
    <EditItemView endpoint="deviceModels" item={item} setItem={setItem}>
      {item &&
        <>
        <div className={classes.root}>
        <Grid container spacing={3}>
         <Grid item xs={8}>
         <Paper elevation={3} >
         <Accordion defaultExpanded>
                     <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                       <Typography variant="subtitle1">
                         {t('sharedRequired')}
                       </Typography>
                     </AccordionSummary>
                     <AccordionDetails className={classes.details}>
                    <Grid container spacing={3}>
                    <Grid item xs={4}>
                       <TextField className={classes.textField}
                         margin="normal"
                         InputProps={{ disableUnderline: true }}
                         value={item.name || ''}
                         onChange={event => setItem({...item, name: event.target.value})}
                         label={t('deviceModel')}
                         variant="standard" />
                         </Grid>
                         <Grid item xs={4}>
                   <TextField className={classes.textField}
                        margin="normal"
                        InputProps={{ disableUnderline: true }}
                        value={item.protocol || ''}
                        onChange={event => setItem({...item, protocol: event.target.value})}
                        label={t('protocol')}
                        variant="standard" />
                        </Grid>
                        <Grid item xs={4}>
                   <TextField className={classes.textField}
                        margin="normal"
                        InputProps={{ disableUnderline: true }}
                        value={item.vendor || ''}
                        onChange={event => setItem({...item, vendor: event.target.value})}
                        label={t('vendor')}
                        variant="standard" />
                        </Grid>
                        <Grid item xs={4}>
                  <TextField className={classes.textField}
                        margin="normal"
                        InputProps={{ disableUnderline: true }}
                        value={item.year || ''}
                        onChange={event => setItem({...item, year: event.target.value})}
                        label={t('year')}
                        variant="standard" />
                        </Grid>
                        <Grid item xs={4}>
                  <TextField className={classes.textField}
                        margin="normal"
                        InputProps={{ disableUnderline: true }}
                        value={item.port || ''}
                        onChange={event => setItem({...item, port: event.target.value})}
                        label={t('port')}
                        variant="standard" />
                        </Grid>
                        </Grid>
                     </AccordionDetails>
                     </Accordion>
           </Paper>
           </Grid>
           <Grid item xs={4}>
           <Paper elevation={3} >
             <Accordion defaultExpanded>
             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography variant="subtitle1">
                {t('sharedAttributes')}
              </Typography>
             </AccordionSummary>

             <AccordionDetails className={classes.details}>
                           <EditAttributesView
                             attributes={item.attributes}
                             setAttributes={attributes => setItem({...item, attributes})}
                             definitions={deviceModelsAttributes}
                             />
                         </AccordionDetails>
         </Accordion>
         </Paper>
         </Grid>
       </Grid>
       </div>
        </>
      }
    </EditItemView>
  );
}

export default DeviceModelPage;
